import {Model} from "ords/dist/model/model"

export class RubricOption extends  Model{

}

export const RubricOptionConfig = {
    name: 'rubricOption',
    model: RubricOption,
    relations: [
    ]
}
